export default __webpack_public_path__ + "static/media/semi-detached-house.fee9a677.png";